import { apiRequest } from '../services/apiClient';

/**
 * Attendance Service
 * Handles all attendance-related API calls
 */
export const attendanceService = {
  /**
   * Get attendance report
   * @param {Object} params - Report parameters
   * @param {string} params.startDate - Start date (YYYY-MM-DD)
   * @param {string} params.endDate - End date (YYYY-MM-DD)
   * @param {number} [params.tenantId] - Tenant ID
   * @param {number} [params.categoryId] - Category ID
   * @param {string} [params.search] - Name/email/username filter
   * @param {number} [params.page] - 0-based page (screen only; omit for full export)
   * @param {number} [params.size] - Page size (screen only; omit for full export)
   * @returns {Promise} API response — paginated object when page/size sent, else full array
   */
  getAttendanceReport: async (params) => {
    try {
      // Combined hd-login: context /gateway, AttendanceController @RequestMapping("/attendance")
      const response = await apiRequest('/gateway/attendance/report', {
        method: 'POST',
        body: params  // apiRequest will stringify this automatically
      });
      return response;
    } catch (error) {
      console.error('Error fetching attendance report:', error);
      throw error;
    }
  },

  /**
   * Download attendance report as PDF
   * @param {Object} params - Report parameters
   * @param {string} params.startDate - Start date (YYYY-MM-DD)
   * @param {string} params.endDate - End date (YYYY-MM-DD)
   * @param {number} params.tenantId - Tenant ID (optional)
   * @param {number} params.categoryId - Category ID (optional)
   * @returns {Promise} Blob response
   */
  downloadAttendanceReportPDF: async (params) => {
    try {
      const token = sessionStorage.getItem('token') || sessionStorage.getItem('authToken');
      
      const BASE_URL = process.env.REACT_APP_BASE_URL ||
                       process.env.REACT_APP_GATEWAY_URL ||
                       process.env.REACT_APP_API_URL ||
                       'http://localhost:8080';

      const response = await fetch(`${BASE_URL}/gateway/attendance/report/pdf`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(params)
      });

      if (!response.ok) {
        throw new Error('Failed to download PDF');
      }

      const blob = await response.blob();
      return blob;
    } catch (error) {
      console.error('Error downloading attendance PDF:', error);
      throw error;
    }
  }
};

export default attendanceService;
